<table *ngIf="requestedSamplings && requestedSamplings.length" class="table table-bordered">
    <thead>
        <tr class="active">
            <th>Laboratory</th>
            <th>Assay Type</th>
            <th>Tissue Type</th>
            <th>Tissue Collection</th>
            <th *ngIf="displayGrowthStage">Growth Stage</th>
            <th *ngIf="displayDaysAfterPlanting">Days after Planting</th>
            <th *ngIf="includeNotes">Notes</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let sampling of requestedSamplings">
            <td>{{ sampling.laboratory }}</td>
            <td>{{ sampling.assay }}</td>
            <td>{{ sampling.tissueType }}</td>
            <td>{{ sampling.tissueCollectionType }}</td>
            <td *ngIf="displayGrowthStage">{{ sampling.growthStage }}</td>
            <td *ngIf="displayDaysAfterPlanting">{{ sampling.daysAfterPlanting }}</td>
            <td *ngIf="includeNotes">{{ sampling.notes }}</td>
        </tr>
    </tbody>
</table>

<div *ngIf="!requestedSamplings || !requestedSamplings.length" class="col-md-offset-2 col-md-10">
    No sampling needs
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/sampling-needs-grid/sampling-needs-grid.component.html